'use client';

import React__default, { useCallback } from 'react';
import { TagContainer, CloseButton } from './styles.js';
import themes from './themes.js';
import Typography from '../Typography/index.js';
import CloseIcon from '../Images/CloseIcon/index.js';

function NTag(_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'filled' : _b, _c = _a.color, color = _c === void 0 ? 'neutral' : _c, _d = _a.size, size = _d === void 0 ? 'medium' : _d, label = _a.label, onClick = _a.onClick, onDelete = _a.onDelete;
    var isHaveCloseButton = !!onDelete;
    var handleClick = useCallback(function (e) {
        e.stopPropagation();
        onClick && onClick();
    }, [onClick]);
    var handleClickDelete = useCallback(function (e) {
        e.stopPropagation();
        onDelete && onDelete();
    }, [onDelete]);
    return (React__default.createElement(TagContainer, { variant: variant, color: color, size: size, onClick: handleClick, id: 'vnw-tag' },
        React__default.createElement(Typography, { variant: 'span', size: 'medium', color: themes[color][variant].text, className: 'tag-typo' }, label),
        isHaveCloseButton ? (React__default.createElement(CloseButton, { onClick: handleClickDelete },
            React__default.createElement(CloseIcon, { width: 16 }))) : null));
}

export { NTag as default };
//# sourceMappingURL=index.js.map
